<div
   style="pointer-events: none"
   class="long-running-loading-indicator"
   *ngIf="isLoading$ | async"
   [class.loading-indicator-bottom]="!indicatorOnTop"
   [class.loading-indicator-top]="indicatorOnTop"
>
   <div class="progress">
      <div class="indeterminate"></div>
   </div>
</div>

<div
   class="long-running-loading-indicator sam-center"
   style="height: 95%"
   *ngIf="showLoadingCircle && (isLoading$ | async)"
>
   <div class="k-i-loading"></div>
</div>

<ng-content></ng-content>
